<div class="row mt-2">
  <div class="col">
    <small>
      <a [routerLink]="['/provider/dashboard']" class="text-secondary">Admin Console&nbsp;</a>
      /<a [routerLink]="['/provider/account-management']" class="text-secondary">&nbsp;Account Management</a>
      /<a [routerLink]="['/provider/dongles']" class="text-secondary">&nbsp;Dongles</a>
    </small>
  </div>
</div>

<div class="row p-2 mt-2">
  <div class="col-12 text-right">
    <button class="btn btn-primary border" data-toggle="modal" data-target="#addDevice" data-backdrop="static"
      data-keyboard="false">Add Device</button>
  </div>
  <div class="col-12 mt-3 table-responsive no-gutter hide-x-scroll">
    <table class="table table-striped tbl-scrollable">
      <thead class="thead-light cursor-pointer">
        <tr>
          <th scope="col" width="10%" class="text-center"><button class="btn btn-outline-danger pt-0 pb-0"
            [disabled]="selectedDevices.length < 1" data-toggle="modal" data-target="#deleteDevice"><i
              class="fa fa-trash"></i></button>
          </th>
          <th scope="col">IMEI ID</th>
          <th scope="col">SIM ID</th>
          <th scope="col">MSISDN</th>
          <th scope="col">Telematics Type</th>
          <th scope="col">Version</th>
          <th scope="col">Sim Status</th>
          <th class="text-right" scope="col">Device Status</th>
        </tr>
      </thead>
      <tbody class="max-height-57">
        <tr class="pointer" *ngFor="let dongle of dongles; let i = index">
          <th width="10%" scope="row" class="text-center pr-0">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" name="checkbox" class="custom-control-input" [disabled]="false"
                id="device_{{i}}" (change)="onDeviceSelected(dongle.id)">
              <label class="custom-control-label" for="device_{{i}}"></label>
            </div>
          </th>
          <td>{{dongle.imeiId}}</td>
          <td>{{dongle.simId}}</td>
          <td>{{dongle.msisdn}}</td>
          <td>{{dongle.telematicsType | customText}}</td>
          <td>{{dongle.firmwareVersion}}</td>
          <td>{{dongle.simStatus}}</td>
          <td class="text-right">{{dongle.deviceStatus}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="dongles == null || dongles.length < 1"
    class="col-12 text-center">
    <h3 class="text-muted">No Devices Available.</h3>
  </div>
</div>

<!--Add Device Modal-->
<div class="modal fade" id="addDevice" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="addDeviceTitle">Add Device</h5>
        <button id="closeAddDevice" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetAddDeviceForm()">&times;</span>
        </button>
      </div>
      <form name="addDevice" #addDeviceForm="ngForm" novalidate (ngSubmit)="addDevice(addDeviceForm)">
        <div class="modal-body">

          <div class="row">
            <div class="col-sm-6 col-12">
              <div class="form-group">
                <label for="model"><span class="maroon astrisk">&#10033;&nbsp;</span>Device Model</label>
                <input type="text" class="form-control" id="type" name="type" placeholder="Device Model" required
                  [(ngModel)]="deviceModel.provisioningData.dongle.model" #type="ngModel">
                <small class="text-danger text-center" *ngIf="type.errors && addDeviceForm.submitted">
                  <p class="mb-0" *ngIf="type.errors.required">*Required</p>
                </small>
              </div>
            </div>
            
            <div class="col-sm-6 col-12">
              <div class="form-group">
                <label for="model"><span class="maroon astrisk">&#10033;&nbsp;</span>IMEI ID</label>
                <input type="text" class="form-control" id="imeiId" name="imeiId" placeholder="IMEI Id" required
                  [(ngModel)]="deviceModel.provisioningData.dongle.imeiId" pattern="[0-9]{15}" maxlength="15" #imeiId="ngModel">
                <small class="text-danger text-center" *ngIf="imeiId.errors && addDeviceForm.submitted">
                  <p class="mb-0" *ngIf="imeiId.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!imeiId.errors.required">Invalid IMEI ID</p>
                </small>
              </div>
            </div>
            <div class="col-sm-6 col-12">
              <div class="form-group">
                <label for="model"><span class="maroon astrisk">&#10033;&nbsp;</span>SIM ID</label>
                <input type="text" class="form-control" id="simId" name="simId" placeholder="SIM ID" required
                  [(ngModel)]="deviceModel.provisioningData.dongle.simId" pattern="[0-9]{20}" maxlength="20" #simId="ngModel">
                <small class="text-danger text-center" *ngIf="simId.errors && addDeviceForm.submitted">
                  <p class="mb-0" *ngIf="simId.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!simId.errors.required">Invalid SIM ID</p>
                </small>
              </div>
            </div>
            <div class="col-sm-6 col-12">
              <div class="form-group">
                <label for="model"><span class="maroon astrisk">&#10033;&nbsp;</span>MSISDN</label>
                <input type="text" class="form-control" id="msisdn" name="msisdn" placeholder="MSISDN" required
                  [(ngModel)]="deviceModel.provisioningData.dongle.msisdn" pattern="[+0-9][0-9]+" maxlength="13" #msisdn="ngModel">
                <small class="text-danger text-center" *ngIf="msisdn.errors && addDeviceForm.submitted">
                  <p class="mb-0" *ngIf="msisdn.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!msisdn.errors.required">Invalid MSISDN</p>
                </small>
              </div>
            </div>
            <div class="col-sm-6 col-12">
              <div class="form-group">
                <label for="model"><span class="maroon astrisk">&#10033;&nbsp;</span>Firmware Version</label>
                <input type="text" class="form-control" pattern="^(\d+\.)?(\d+\.)?(\*|\d+)$" id="firmwareVersion"
                  name="firmwareVersion" placeholder="1.0.1" required [(ngModel)]="deviceModel.provisioningData.dongle.firmwareVersion"
                  #firmwareVersion="ngModel">
                <small class="text-danger text-center" *ngIf="firmwareVersion.errors && addDeviceForm.submitted">
                  <p class="mb-0" *ngIf="firmwareVersion.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!firmwareVersion.errors.required">Invalid Version</p>
                </small>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
            (click)="resetAddDeviceForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary btn-80">SAVE</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Delete Device Modal -->
<div class="modal fade" id="deleteDevice" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="deleteDeviceTitle">Delete Device(s)</h5>
        <button type="button" class="close" (click)="cancelDeleteDevice()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center" style="min-height: 0vh;">
        <h5 class="mt-5 mb-5">Confirm deleting the selected device(s).</h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" (click)="cancelDeleteDevice()" data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" data-dismiss="modal" (click)="onDeleteDevices()">OK</button>
      </div>
    </div>
  </div>
</div>